// === Card Rendering Orchestrator ===

import store from '../state/store.js';
import { getElements } from '../utils/dom.js';
import { filterAdvisories } from '../services/filter-service.js';
import { createCard } from './grid-card.js';
import { createListItem } from './list-item.js';

export function renderCards() {
  const els = getElements();
  const visibleItems = filterAdvisories();

  const urgentItems = visibleItems.filter(i => i.meta.urgency === 'Time-sensitive');
  const normalItems = visibleItems.filter(i => i.meta.urgency !== 'Time-sensitive');

  els.urgentGrid.innerHTML = '';
  els.normalGrid.innerHTML = '';

  urgentItems.forEach(item => {
    const el = store.currentView === 'grid' ? createCard(item, true) : createListItem(item, true);
    els.urgentGrid.appendChild(el);
  });

  normalItems.forEach(item => {
    const el = store.currentView === 'grid' ? createCard(item, false) : createListItem(item, false);
    els.normalGrid.appendChild(el);
  });

  els.urgentSection.style.display = urgentItems.length > 0 ? 'block' : 'none';

  if (visibleItems.length === 0) {
    els.emptyMsg.style.display = 'block';
    els.normalGrid.style.display = 'none';
    document.getElementById('normalTitle').style.display = 'none';
  } else {
    els.emptyMsg.style.display = 'none';
    els.normalGrid.style.display = (store.currentView === 'grid' ? 'grid' : 'flex');
    document.getElementById('normalTitle').style.display = 'flex';
  }
}
